// version-check.service.ts
import { inject, Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { login } from './jkUser';
import { OrmService } from './jkOrm';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  public orm: OrmService = inject(OrmService);
  appId: string = '';
  version: string = '';
  constructor() { }
  // 檢查遠端版本
  public initVersionCheck(appId: string, version: string, frequency = 5 * 60 * 1000) {
    this.appId = appId;
    this.version = version;
    interval(frequency).subscribe(() => {
      this.checkVersion();
    });
  }

  private checkVersion() {
    const sql = `select * from CMSKB where KB001='${this.appId}-version' `;
    this.orm.simpleSql(login.host, sql).subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          const currentVersion = res[0].KB002;
          if (currentVersion > this.version) {
            if (confirm(`發現新版本，是否立即更新？(db:${currentVersion} > web:${this.version})`)) {
              this.forceUpdate();
            }
          } else if (currentVersion < this.version) {
            console.warn(`資料庫CMSKB版本落後: (db:${currentVersion} < web:${this.version})`);
          }
          return;
        } else {
          console.error(`資料庫CMSKB找不到版本資料:${this.appId}-version`);
        }
      },
      error: (err: any) => {
        console.error('Error fetching version from DB', err);
        //this.fetchRemoteVersion(url);
      }
    });

  }

  private forceUpdate() {
    // 清除快取
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }

    // 重新載入頁面
    window.location.reload();
  }
}
